import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Engineered, not assembled",
    body: "Every pad and rotor is developed in-house and dyno-tested against real-world abuse before it ever reaches a wheel.",
  },
  {
    num: "02",
    title: "Made in the USA & UK",
    body: "Precision friction technology built where it was invented — no shortcuts, no compromise on materials.",
  },
  {
    num: "03",
    title: "Trusted by racers",
    body: "From MotoGP paddocks to 55,000 dealers worldwide, riders reach for EBC when the corner comes up fast.",
  },
];

export const Ethos = () => {
  return (
    <section id="ethos" data-testid="ethos-section" className="relative bg-black py-20 sm:py-28 border-t border-white/10">
      <div className="mx-auto max-w-[1600px] px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-ebc-red mb-4">/ Ethos</p>
          <h2 className="font-display uppercase leading-[0.85] tracking-tight text-white text-5xl sm:text-7xl lg:text-8xl max-w-4xl">
            The world leader in <span className="text-stroke">braking.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 border-t border-white/10">
          {CHAPTERS.map((c, i) => (
            <Reveal
              key={c.num}
              delay={i * 0.08}
              className="border-b md:border-b-0 md:border-r border-white/10 last:border-r-0 p-7 sm:p-9"
            >
              <span className="font-display text-6xl sm:text-7xl text-ebc-red/90 leading-none">
                {c.num}
              </span>
              <h3 className="mt-6 font-display uppercase text-2xl sm:text-3xl tracking-wide text-white">
                {c.title}
              </h3>
              <p className="mt-3 text-sm sm:text-base text-neutral-400 leading-relaxed">
                {c.body}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
